export const INITIAL_VALUES = {
  email: '',
  password: '',
  remember: false,
};
